import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/shared/Services/storage.service';
import { VerificationLinkStateService } from './verification-link-state.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private storageService: StorageService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return AuthGuard.checkLogin(this.router, this.storageService, state.url);
  }

  private static checkLogin(router: Router, storageService: StorageService, url: string): Observable<boolean | UrlTree> | boolean {
    if (storageService.isLoggedIn()) {
      return true;
    } else {
      storageService.removeLocalStorage();
      router.navigate(['/'], { queryParams: { returnUrl: url } });
      return false;
    }
  }

  static canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const storageService = new StorageService(new Router(),new VerificationLinkStateService());
    return AuthGuard.checkLogin(new Router(), storageService, state.url);
  }
}
